import React from "react";
import NetworkLayout from "./NetworkLayout";
import FinlandNavigation from "./FinlandNavigation";
import FinlandMainCol from "./FinlandMainCol";
import FinlandSideCol from "./FinlandSideCol";

import styles from "../assets/styles/FinlandLayout.module.scss";

const FinlandLayout = ({
	children,
	title,
	trail,
	headline,
	description,
	image,
	location
}) => {
	return (
		<NetworkLayout title={title} trail={trail}>
			<div className={styles.root}>
				<div className={styles.navigation}>
					<FinlandNavigation location={location} />
				</div>
				<div className={styles.content}>
					<FinlandSideCol
						headline={headline}
						description={description}
						image={image}
					/>
					<FinlandMainCol>{children}</FinlandMainCol>
				</div>
			</div>
		</NetworkLayout>
	);
};

export default FinlandLayout;
